// UI source value sent via the `X-Ui-Source` header on bank line match
// approve/unapprove requests, so the backend can attribute the tracked
// "Bank Line Match Approved / Un-Approved" events to this (legacy) view.
module.exports = 'old_recon_view'
